import moment from 'moment';

const DATE_KEY_FORMAT = 'YYYY-MM-DD';
const DATE_KEY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

const isDateKey = (value) => typeof value === 'string' && DATE_KEY_REGEX.test(value);

const toLocalDateFromDateKey = (dateKey) => moment(dateKey, DATE_KEY_FORMAT, true).toDate();

export const formatLocalizedDate = (date, format = 'll') => {
  if (!date) return '';

  const stillUtc = moment.utc(date).toDate();
  return moment(stillUtc).local().format(format);
};

export const formatMemberProfileChartDate = (value, format = 'll') => {
  if (!value) return '';

  if (isDateKey(value)) {
    return moment(value, DATE_KEY_FORMAT, true).format(format);
  }

  return formatLocalizedDate(value, format);
};

// Converts a date key or UTC timestamp to a local Date object.
// Primarily used for testing round-trip parsing (dateKey -> Date -> dateKey).
export const toMemberProfileChartDate = (value) => {
  if (!value) return null;

  if (isDateKey(value)) {
    return toLocalDateFromDateKey(value);
  }

  const stillUtc = moment.utc(value).toDate();
  return moment(stillUtc).local().toDate();
};

export const toMemberProfileChartDateKey = (value) => {
  if (!value) return null;

  if (isDateKey(value)) return value;

  // Date objects are already in local time, so format directly without UTC conversion.
  // Timestamps/strings are assumed to be UTC and need conversion to local time first.
  if (value instanceof Date) {
    return moment(value).format(DATE_KEY_FORMAT);
  }

  return moment.utc(value).local().format(DATE_KEY_FORMAT);
};

export const getMemberProfileChartCutoffDateKey = (lookbackDays, now = new Date()) => {
  const days = Number(lookbackDays);
  if (!Number.isFinite(days) || days <= 0) return null;

  return moment(now).startOf('day').subtract(days - 1, 'days').format(DATE_KEY_FORMAT);
};
